import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var IS_MANAGED_ENV = false;
export var IS_ENV_WITH_UPDATES_ENABLED = false;
export var IS_ENV_WITHOUT_UPDATES_ENABLED = false;
export var manifestBaseUrl = null;
export function downloadAsync(uri, hash, type, name) {
  return _regeneratorRuntime.async(function downloadAsync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", uri);

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}
export function getManifest() {
  return {};
}